import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/logos/vibex media.svg';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeNavbar = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark sticky-top">
      <div className="container">
        <Link className="navbar-brand" to="/" onClick={closeNavbar}>
            <img src={logo} alt="VibeX.media" className="nav-logo" />
          {/* Vibex Media */}
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <NavLink className="nav-link" to="/" end onClick={closeNavbar}>
                Home
              </NavLink>
            </li>
            
            {/* Services Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="servicesDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Services
              </a>
              <ul className="dropdown-menu" aria-labelledby="servicesDropdown">
                <li>
                  <Link className="dropdown-item" to="/our-services/advertisement" onClick={closeNavbar}>
                    <i className="fas fa-ad me-2"></i> Advertisement
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/our-services/marketing" onClick={closeNavbar}>
                    <i className="fas fa-bullseye me-2"></i> Marketing
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/our-services/press-release" onClick={closeNavbar}>
                    <i className="fas fa-newspaper me-2"></i> Press Release
                  </Link>
                </li>
              </ul>
            </li>
            
            <li className="nav-item">
              <NavLink className="nav-link" to="/portfolio" onClick={closeNavbar}>
                Portfolio
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/Blogs" onClick={closeNavbar}>
                Blogs
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/contact" onClick={closeNavbar}>
                Contact
              </NavLink>
            </li>
          </ul>
          <Link to="/get-started" className="btn btn-light ms-3" onClick={closeNavbar}>
            Get Started
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;